

import { RequestDetailEdit } from '../../../models/requestDetailEdit';
import { RequestPackages } from '../../../models/requestPackages';


export class PackagesController implements ng.IController {
    static $inject = ['$mdMedia', '$mdDialog'];

    constructor(private _$mdMedia: angular.material.IMedia, private _$mdDialog: ng.material.IDialogService
        ) {

    }

    isFormRequestedFromAddNewRequest: boolean;
    requestDetailEdit: RequestDetailEdit;

    _isNewPackage: boolean;
    _editIndex: number;

    $onInit() { }

    dimension(len: string, width: string, height: string, uom: string): string {
        return len + 'L x'+ width + 'W x'  + height + 'H ' + uom;
    }

    isPackageTypeEnvelope(packageTypeId : string): boolean {
        if (packageTypeId !== undefined && packageTypeId !== null && packageTypeId.toLocaleLowerCase() === "envelope")
            return true;
        return false;
    }

    get showErrorMessageOnPackagesInValidOnReceiverEditScreen() {
        
        if (!this.isFormRequestedFromAddNewRequest && !this.isValid) {
            
            return true;
        }
        return false;
    }
    

    get isSubScrollContainer(): boolean {
        return this._$mdMedia('gt-md');
    }

    get isScrollContainer(): boolean {
        return this._$mdMedia('sm') || this._$mdMedia('md');
    }

    get isNewPackage(): boolean {
        return this._isNewPackage;
    }

    get editIndex(): number {
        return this._editIndex;
    }

    deletePackage(event: MouseEvent, index: number): void {
        this.onDeletingPackage(event, index);
    }

    private onDeletingPackage(event: MouseEvent, index: number) {

        this.requestDetailEdit.requestMaterial.requestPackages[index].isDeleted = true;

        if ((this.requestDetailEdit.requestMaterial.requestPackages[index].packageId === undefined ||
            this.requestDetailEdit.requestMaterial.requestPackages[index].packageId === null) &&
            (this.requestDetailEdit.requestMaterial.requestPackages[index].isDeleted)) {
            
            this.requestDetailEdit.requestMaterial.requestPackages.splice(index, 1);
        }

        this.updatePackagesToAssignMaterialsOnDelete(index);
       
        this.calculateAssignedPcOfAssignedMaterials();
    }


    private isPackagesAssignmentExistsInAssignedMaterials(requestDetailEdit: RequestDetailEdit): boolean {

        if (requestDetailEdit !== undefined &&
            requestDetailEdit.requestMaterial !== undefined &&
            requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage !== undefined) {

            for (var eachAssignedMaterialToPackage of requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage) {
                if (eachAssignedMaterialToPackage !== undefined && eachAssignedMaterialToPackage !== null &&
                    (!eachAssignedMaterialToPackage.requestMaterials.isDeleted) &&
                    eachAssignedMaterialToPackage.assignedPc !== undefined &&
                    eachAssignedMaterialToPackage.assignedPc !== null && eachAssignedMaterialToPackage.assignedPc > 0) {
                    return true;
                }

            }

        }
        return false;
    }

  
    private calculateAssignedPcOfAssignedMaterials() {
        for (var iam = 0; iam < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; iam++) {
            if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam] !== undefined &&
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials !==
                undefined &&
                !this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestMaterials
                    .isDeleted) {
                var assignedPc = 0;
                for (let assignedMaterialRequestPackage of this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].requestPackages.filter(o => !o.isDeleted)) {

                    assignedPc = assignedPc + (assignedMaterialRequestPackage.quantity !== undefined && assignedMaterialRequestPackage.quantity !== null ?
                        assignedMaterialRequestPackage.quantity : 0);
                }

                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[iam].assignedPc = angular
                    .copy(assignedPc);
            }
        }
    }

    

   updatePackagesToAssignMaterialsOnDelete(packageEditIndex: number) {
       for (var i = 0; i < this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage.length; i++) {
           if (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i]
               .requestPackages[packageEditIndex] !==
               undefined) {
               this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i]
                   .requestPackages[packageEditIndex].isDeleted = true;
           }

           if ((this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[packageEditIndex].packageId === undefined ||
                this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[packageEditIndex].packageId === null) &&
                (this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages[packageEditIndex].isDeleted)) {

                    this.requestDetailEdit.requestMaterial.requestAssignedMaterialToPackage[i].requestPackages.splice(packageEditIndex, 1);
            }
        }
    }


   get isValid(): boolean {
       if (this.requestDetailEdit !== undefined &&
           this.requestDetailEdit.requestMaterial !== undefined &&
           this.requestDetailEdit.requestMaterial.requestPackages !== undefined &&
           this.requestDetailEdit.requestMaterial.requestPackages.filter(o => !o.isDeleted).length > 0 &&
           this.requestDetailEdit.requestMaterial.requestPackages.filter(o => !o.isDeleted).length <= 75) {
           return true;
       }
       return false;
   }

   set isValid(val: boolean) { }

   addPackage(event: MouseEvent, index: number): void {

       this.addPackageDialogShow(event, index);
   }

    get isAddPackageAllowed(): boolean {
        if (this.requestDetailEdit !== undefined &&
            this.requestDetailEdit.requestMaterial !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages !== undefined &&
            this.requestDetailEdit.requestMaterial.requestPackages.filter(o => !o.isDeleted).length > 75) {
            return false;
        }
        return true;
    }

    private addPackageDialogShow(event: MouseEvent, index: number) {
        if (index === -1) {
            this._isNewPackage = true;
        } else {
            this._isNewPackage = false;
            this._editIndex = index;
        }

        this._$mdDialog.show({
            template: `<md-dialog flex> <package-dialog layout-fill
                            request-detail-edit="vm.requestDetailEdit"
                            edit-index="vm.editIndex" is-new-package = "vm.isNewPackage">
                            </package-dialog> </md-dialog>`,

            parent: angular.element(document.body),
            targetEvent: event,
            onComplete: () => {
                angular.element(document.querySelector('md-dialog')).addClass('min-size-personnel');
            },
            controller: () => { },
            locals: {
                requestDetailEdit: this.requestDetailEdit,
                editIndex: this.editIndex,
                isNewPackage: this.isNewPackage
            },
            bindToController: true,
            controllerAs: 'vm'

        });
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/packages/controllers/packagesController.ts
 **/